import { totalCount } from '@jane/bloom/utils/totalCount';
import type { Cart } from '@jane/bloom/viewModels/schemas/checkout';

interface ProductCountInCartArgs {
  cart: Cart;
  currentStoreId?: number;
  productId?: number;
}

export const productCountInCart = ({
  cart,
  currentStoreId,
  productId,
}: ProductCountInCartArgs) => {
  return totalCount(
    cart.items.filter((cartItem) =>
      productId === undefined
        ? true
        : cartItem.productId === productId && currentStoreId === cart.storeId
    )
  );
};
